export default __webpack_public_path__ + "static/media/cg.a88f186e.svg";